import { render, staticRenderFns } from "./ScreenControl.vue?vue&type=template&id=0d310556&scoped=true&"
import script from "./ScreenControl.vue?vue&type=script&lang=js&"
export * from "./ScreenControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d310556",
  null
  
)

export default component.exports